import React, { useContext, useEffect, useState } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { Container } from "react-bootstrap";
import { get } from "lodash";
import { HeaderNew, SidebarNew, SideBarContentNew } from "../components";
import { appLayoutStore, setSelectedMenu } from "../contexts";
import { ApplicationRoute, ROUTES } from "../utils";
import tenantConfig from "../mocks/tenantOne.json";

const withNewLayout = (Component) => {
  const ComposedComponent = (props) => {
    const { location } = props;
    const { state, dispatch } = useContext(appLayoutStore);
    const [expandSidebar, setExpandSidebar] = useState(false);
    const sidebarMouseoverHandler = () => {
      setExpandSidebar(!expandSidebar);
    };

    const menu = tenantConfig.menuItems;
    // enven to handle location change
    useEffect(() => {
      dispatch(setSelectedMenu(location.pathname));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    const isSearch = ["plans", "companys", "employees"].includes(
      location.pathname.slice(1)
    );
    const isAllowed = isSearch
      ? menu.includes(location.pathname.slice(1, location.pathname.length - 1))
      : true;

    return (
      <SidebarNew className="with-new-layout" content={<SideBarContentNew />}>
        <HeaderNew seletedRoute={get(state, "selectedMenu")} />
        <Container className="app-layout" fluid>
          <div className="sidebar">
            <SideBarContentNew
              onClickLeft={() => {
                sidebarMouseoverHandler();
              }}
              onClickRight={() => {
                sidebarMouseoverHandler();
              }}
            />
          </div>
          <Component {...props} />
        </Container>
      </SidebarNew>
    );
  };
  return withRouter(ComposedComponent);
};

export default withNewLayout;
